import {
  FormlyBaseFormConfig,
  FormlyBaseFormExpressions,
} from '../../services/formly/formly-base-config/formly-base-config.model';
import { PprfBuildingFormControlName } from './pprf-building-form/pprf-building-form.model';
import { PprfParcelFormControlName } from './pprf-parcel-form/pprf-parcel-form.model';
import { PprfPremisesFormControlName } from './pprf-premises-form/pprf-premises-form.model';
import { PprfPropertyFormControlName } from './pprf-property-form/pprf-property-form.model';
import { PprfTransactionAndPricingFormControlName } from './pprf-transaction-and-pricing-form/pprf-transaction-and-pricing-form.model';
import { PprfStaticDictionaryField } from './services/pprf-form-dictionary/pprf-form-dictionary.model';

export type PropertyPriceRegisterFormControlNames =
  | PprfTransactionAndPricingFormControlName
  | PprfPropertyFormControlName
  | PprfPremisesFormControlName
  | PprfParcelFormControlName
  | PprfBuildingFormControlName;

export type PropertyPriceRegisterFormExpressions = FormlyBaseFormExpressions<
  PropertyPriceRegisterFormControlNames,
  PprfStaticDictionaryField
>;

export const pprfDefaultValue = new PprfStaticDictionaryField(
  null,
  'DICT_DEFAULT_NAME',
);

export class PropertyPriceRegisterFormConfig extends FormlyBaseFormConfig<
  PropertyPriceRegisterFormControlNames,
  PprfStaticDictionaryField
> {
  constructor(
    public transactionAndPricingTabKey = 'PROPERTY_PRICE_REGISTER_FORM.TRANSACTION_AND_PRICING.TITLE',
    fieldsToHide: PropertyPriceRegisterFormControlNames[] = [],
    propertiesToOverride: PropertyPriceRegisterFormExpressions = {},
  ) {
    super(fieldsToHide, propertiesToOverride);
  }
}
